module.exports = __webpack_public_path__ + "static/johnathan_b.be7edd78.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/johnathan_b.png
// module id = 1716
// module chunks = 35783957827783